import { render, staticRenderFns } from "./TransformGhost.vue?vue&type=template&id=a445bdfa&lang=pug&"
import script from "./TransformGhost.vue?vue&type=script&lang=js&"
export * from "./TransformGhost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports